<template>
  <div class="cdwriteam">
    <sec-title
      Text="服务团队&评价"
      desc-text="目前已有超过1w家企业通过律观网找到专业律师"
      class="text_center"
    />
    <cardswipe />

    <div class="bom between wrap">
      <div class="commentlist between wrap">
        <div class="comitem mt30" v-for="item in 4" :key="item">
          <div class="inadr">
            <span>asda***asd</span>
            <span>山东济南</span>
          </div>
          <div><el-rate disabled-void-color="#ccc" v-model="value" disabled> </el-rate></div>
          <div class="plcont">
            一直很信任华律网在上面找律师帮忙，
            注册和兄弟一起办培训班急需专业的合同，给钱后很快就发给我了，我们一起看了没得问题，感谢律师，合同写的不错
          </div>
          <div class="between typri">
            <div class="tag">婚姻家庭</div>
            <div class="pri">￥149</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import cardswipe from '../components/cardswipe'
export default {
  components: {
    secTitle,
    cardswipe,
  },
  data() {
    return {
      value: 3,
      swiact: 0,
    };
  },
  methods: {
    chaswi(e) {
      console.log(e);
      this.swiact = e;
    },
    prev() {
      this.$refs.tempswi.prev();
    },
    next() {
      this.$refs.tempswi.next();
    },
  },
};
</script>

<style lang="scss" scoped>
.cdwriteam {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .top {
  }
  .bom {
    .commentlist {
      .comitem {
        width: 550px;
        height: 150px;
        .inadr {
          font-size: 12px;
          color: #999;
          line-height: 16px;
          margin-bottom: 8px;
          span{
            margin-right: 20px;
          }
        }
        .plcont {
          margin-top: 8px;
          margin-bottom: 10px;
          font-size: 14px;
          color: #666;
          height: 44px;
        }
        .typri {
          .tag {
            cursor: pointer;
            padding: 0 20px;
            line-height: 24px;
            font-size: 12px;
            color: #666;
            background-color: #e8e8e8;
          }
          .pri {
            font-size: 18px;
            color: #999;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>